export const formatLetterAvatar = (str: string | null | undefined): string => {
    if (!str) {
        return ''
    }

    return str.trim().charAt(0).toUpperCase()
}
